

























import Vue from 'vue'
import moment from 'moment'
import _ from 'lodash'
import XDropdown, { OptionEntry } from '../Dropdown/XDropdown.vue'

type Ym = 'y' | 'm'

type Data = {
  y: number
  m: number
}

type Props = {
  value?: Date | string
  dateFormat?: string
}

type Methods = {
  options: (type: Ym) => OptionEntry<number>[]
  toDate: (y: number, m: number) => Date | undefined
  onChange: (type: Ym) => void
}
// TODO https://www.npmjs.com/package/vue-datetime 等導入するか検討
export default Vue.extend<Data, Methods, {}, Props>({
  name: 'XMonthPicker',
  components: { XDropdown },
  props: {
    value: {
      type: [Date, String],
      required: false,
    },
    dateFormat: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      y: moment().year(),
      m: moment().month() + 1,
    }
  },
  computed: {
    yearOptions() {
      return this.options('y')
    },
    monthOptions() {
      return this.options('m')
    },
  },
  methods: {
    options(type) {
      const year = moment().year()
      const month = 12
      const values = {
        y: _.range(year - 10, year + 10),
        m: _.range(1, month + 1),
      }[type]
      const opts = values.map((value) => ({
        value,
        label:
          String(value) +
          (type === 'y' ? this.$tc('common.year') : this.$tc('common.month')),
      }))
      return [...opts]
    },
    toDate(y, m) {
      return moment()
        .year(y as number)
        .month((m as number) - 1)
        .date(1)
        .toDate()
    },
    onChange(type) {
      return (v: number) => {
        this[type] = v
        const date = this.toDate(this.y, this.m)
        this.$emit(
          'input',
          this.dateFormat && date ? moment(date).format(this.dateFormat) : date
        )
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        if (newValue) {
          const date = moment(newValue)
          this.y = date.year()
          this.m = date.month() + 1
        }
      },
    },
  },
})
